import BaseApi from "../baseApi";

export default {
  async create() {
    return await BaseApi.post('/api-article/v1/zsdb/create');
  }
}
